import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { legalDocsByAudience } from '../../data/legalDocs';
import { LegalSection } from '../../components/legal/LegalSection';
import { NavMorph } from '../../components/layout/NavMorph';
import { Footer } from '../../components/layout/Footer';
import { GetInTouchModal } from '../../components/modals/GetInTouchModal';

export const LegalHubPage: React.FC = () => {
  const [getInTouchOpen, setGetInTouchOpen] = useState(false);
  const handleGetInTouch = () => setGetInTouchOpen(true);

  return (
    <div className="relative min-h-screen bg-black overflow-x-hidden">
      {/* Background effects */}
      <div className="fixed inset-0 pointer-events-none">
        {/* Vignette */}
        <div
          className="absolute inset-0"
          style={{
            background: `radial-gradient(
              circle at 50% 20%,
              rgba(0, 0, 0, 0.3) 0%,
              rgba(0, 0, 0, 0.8) 50%,
              rgba(0, 0, 0, 0.95) 100%
            )`,
          }}
        />

        {/* Noise texture */}
        <div
          className="absolute inset-0 opacity-[0.03] mix-blend-overlay"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'repeat',
          }}
        />

        {/* Subtle emerald glow */}
        <div
          className="absolute inset-0"
          style={{
            background: `radial-gradient(
              ellipse at 50% 10%,
              rgba(40, 230, 117, 0.03) 0%,
              transparent 50%
            )`,
          }}
        />
      </div>

      {/* Navigation */}
      <NavMorph onGetInTouchClick={handleGetInTouch} />

      {/* Main content */}
      <main className="relative z-10 pt-32 pb-20 px-6">
        <div className="w-full max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16 md:mb-24">
            <motion.h1
              className="text-4xl md:text-5xl lg:text-6xl font-semibold text-white/95 mb-6 leading-tight"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.8,
                ease: [0.25, 0.1, 0.25, 1],
              }}
            >
              Espace juridique
            </motion.h1>

            <motion.p
              className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.8,
                delay: 0.1,
                ease: [0.25, 0.1, 0.25, 1],
              }}
            >
              Retrouvez ici nos documents et politiques.
            </motion.p>
          </div>

          {/* Sections */}
          <div className="space-y-16 md:space-y-24">
            <LegalSection
              title="Pour les clients"
              docs={legalDocsByAudience.clients}
              index={0}
            />

            <LegalSection
              title="Pour les candidats"
              docs={legalDocsByAudience.candidates}
              index={1}
            />

            {legalDocsByAudience.partners.length > 0 && (
              <LegalSection
                title="Pour les partenaires"
                docs={legalDocsByAudience.partners}
                index={2}
              />
            )}
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer />
      <GetInTouchModal open={getInTouchOpen} onClose={() => setGetInTouchOpen(false)} />
    </div>
  );
};
